var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1939 38.5813C28.3426 37.4868 35 33.5546 35 23.3878C35 14.137 28.6209 7.97571 24.0322 5.14506C23.016 4.51564 21.8235 5.34263 21.8235 6.59273V9.78879C21.8235 12.31 22.3407 13.8545 20.2661 16.8288C16.9076 21.6436 13.5461 21.0788 12.7061 19.3788C11.8661 17.6788 11.8661 16.8288 11.7106 13.394C9.40635 15.256 7 18.5255 7 23.386C7 35.8188 15.7113 38.9292 20.0661 38.9292C20.3198 38.9292 20.5866 38.9187 20.8633 38.903C18.7122 38.7089 15.2353 37.2927 15.2353 32.7119C15.2353 29.1277 17.6976 26.7062 19.5687 25.526C20.0727 25.2113 20.6607 25.6222 20.6607 26.2429V27.2744C20.6607 28.0612 20.9489 29.2938 21.6325 30.1365C22.4066 31.0912 23.5414 30.0911 23.632 28.8357C23.6616 28.4406 24.0372 28.1888 24.36 28.3882C25.4158 29.0438 26.7647 30.4425 26.7647 32.7119C26.7647 36.2926 24.9052 37.9396 23.1939 38.5813Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurn);
export default __webpack_public_path__ + "static/media/burn.bb43e536a9d004ec629240c732ceab1f.svg";
export { ForwardRef as ReactComponent };